module.exports = __webpack_public_path__ + "img/6.afb7c0a3.jpg";